/**
 * Created by slava on 02.02.17.
 */

const BoosterCell = function (x, y) {
    BaseCell.call(this, x, y);
    this.movable = true;
    this.hurtable = false;
    this.putInPoolAvailable = true;
    this.fallThroughBarrier = true;
    this.selectType();
    cleverapps.metrics.logEvent(cleverapps.EVENTS.BOOSTER_CELL_ADDED);

    const game = Game.currentGame;
    if (game) {
        game.boosterAdded = true;
    }
};

BoosterCell.prototype = Object.create(BaseCell.prototype);
BoosterCell.prototype.constructor = BoosterCell;

BoosterCell.prototype.save = function () {
    return BoosterCell.CODES.concat(this.type);
};

BoosterCell.prototype.load = function (data) {
    if (data[1] !== undefined) {
        this.type = parseInt(data[1]);
    }
};

BoosterCell.prototype.onTouchEnd = function () {
    this.animate(BaseCell.ANIMATION_DOWN);
    cleverapps.notification.create(Messages.get("Booster.MoveToDown"));
};

BoosterCell.listAvailable = function () {
    return Game.currentGame.boosters.list.filter((booster) => !booster.isDisabled() && booster.id !== 2).map((booster) => booster.id);
};

BoosterCell.prototype.selectType = function () {
    this.type = PseudoRandom.GET().choose(BoosterCell.listAvailable());
};

BoosterCell.prototype.getViewClass = function () {
    return BoosterCellView;
};

BoosterCell.prototype.onBurnStage = function () {
    if (Game.currentGame) {
        for (let i = this.y + 1; i < Field.SIZE; i++) {
            if (Game.currentGame.field.inField(i, this.x)) {
                return;
            }
        }
        this.explode();
        Game.currentGame.addBoosterCellReward(this);
    }
};

BoosterCell.prototype.explodeDuration = function () {
    return 1;
};

BoosterCell.isNeedToAdd = function (moves, levelMoves) {
    if (Game.currentGame.boosterAdded) {
        return false;
    }

    if (BoosterCell.listAvailable().length === 0) {
        return false;
    }

    if (Game.currentGame.level.isRegular()) {
        if (levelMoves > 15 && levelMoves - moves > 2 && moves > 5 && Math.random() < 0.08 / (levelMoves - 8)) {
            let hasBooster = false;

            const field = Game.currentGame.field;

            field.nextCells.forEach((cell) => {
                if (cell === BoosterCell.CODES[0]) {
                    hasBooster = true;
                }
            });

            if (!hasBooster) {
                return true;
            }
        }
    }
    return false;
};
